<template>
<view>
    <HeaderPage/>
    <div class="container">
        <div class="row">
            <div class="col-md-4 zhengwu">
                <ul class="nav nav-tabs zhengwu-tab" role="tablist">
                    <li class="nav-item" v-for="(item,index) in peoples" :key="index">
                    <a class="nav-link" :class="index>0?'':'active'" data-bs-toggle="tab" :href="'#menu'+index">{{item.name}}</a>
                    </li>
                </ul>
                <!-- Tab panes -->
                <div class="tab-content zhengwu-con" style="background:#fff">
                    <div v-for="(item,index) in peoples" :key="index" :id="'menu'+index" class="tab-pane" :class="index>0?'':'active'"><br>
                        <div class="people">
                            <div v-for="(people,index) in item.data" :key="index">
                                <router-link :to="'/search?keyword='+people.name" target="_blank"><span class="serachName">{{people.name}}</span></router-link>
                                <span>{{people.description}}</span></div>
                        </div>                    
                    </div>
                </div>
            </div>
            <div class="col-md-8">
                <div class="row">
                    <div class="col-xs-12 col-sm-7" style="padding-left:3px;">
                        <div id="zhengwu_foucs" class="carousel slide foucs_zhengwu" data-bs-ride="carousel">
                            <!-- 指示符 -->
                            <div class="carousel-indicators">
                                <button type="button" v-for="(item,index) in newsfoucs" :key="index" data-bs-target="#zhengwu_foucs" :data-bs-slide-to="index" :class="index>0?'':'active'"></button>
                            </div>
                            <div class="carousel-inner">
                                <div class="carousel-item" v-for="(item,index) in newsfoucs" :key="index" :class="index>0?'':'active'">
                                    <a :href="item.link" v-if="item.type==4" target="_blank">
                                        <img class="foucs_img" :src="item.cover" :alt="item.title">
                                    </a>
                                    <router-link :to="'/special/node_'+item.basic_id+'.html'" v-else-if="item.type==3" target="_blank">
                                        <img class="foucs_img" :src="item.cover" :alt="item.title">
                                    </router-link>
                                    <router-link :to="'/video/show-'+item.basic_id+'.html'" v-else-if="item.type==2" target="_blank">
                                        <img class="foucs_img" :src="item.cover" :alt="item.title">
                                    </router-link>
                                    <router-link :to="'/album/show-'+item.basic_id+'.html'" v-else-if="item.type==1" target="_blank">
                                        <img class="foucs_img" :src="item.cover" :alt="item.title">
                                    </router-link>
                                    <router-link :to="'/article/show-'+item.basic_id+'.html'" v-else target="_blank">
                                        <img class="foucs_img" :src="item.cover" :alt="item.title">
                                    </router-link>
                                    <div class="foucs_text">
                                        <div class="tit">{{item.title}}</div>
                                    </div>
                                </div>
                            </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#zhengwu_foucs" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon"></span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#zhengwu_foucs" data-bs-slide="next">
                                <span class="carousel-control-next-icon"></span>
                            </button>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-5 bt_left">
                        <div class="index_news">
                            <div class="index_news_tit">
                                <div class="news_type">领导活动</div>
                                <div class="news_more">
                                    <router-link to="/list_90.html" target="_blank">更多</router-link>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="index_news_list">
                                <div class="news-a-no" v-for="(item,index) in lingdao" :key="index">
                                    <a :href="item.link" v-if="item.type==4" target="_blank">
                                        
                                        <div class="tit">{{item.title}}</div>
                                    </a>
                                    <router-link :to="'/special/node_'+item.basic_id+'.html'" v-else-if="item.type==3" target="_blank">
                                        
                                        <div class="tit">{{item.title}}</div>
                                    </router-link>
                                    <router-link :to="'/video/show-'+item.basic_id+'.html'" v-else-if="item.type==2" target="_blank">
                                        
                                        <div class="tit">{{news.title}}</div>
                                    </router-link>
                                    <router-link :to="'/album/show-'+item.basic_id+'.html'" v-else-if="item.type==1" target="_blank">
                                        
                                        <div class="tit">{{item.title}}</div>
                                    </router-link>
                                    <router-link :to="'/article/show-'+item.basic_id+'.html'" v-else target="_blank">
                                        
                                        <div class="tit">{{item.title}}</div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="margin-top:15px;">
                    <div class="row">
                        <div class="col-xs-12 col-sm-6" v-for="(item,index) in oneline" :key="index" :class="{'bt_right': index == 0 ,'bt_left': index == 1}">
                            <div class="index_news">
                                <div class="index_news_tit">
                                    <div class="news_type">{{item.name}}</div>
                                    <div class="news_more">
                                        <router-link :to="'/list_'+item.id+'.html'" target="_blank">更多</router-link>
                                    </div>
                                    <div class="clear"></div>
                                </div>
                                <div class="index_news_list">
                                    <div class="index_news_photo" v-if="!isObjectEmpty(item.topimg)" style="display:none">
                                        <div class="img">
                                            <a :href="item.topimg.link" v-if="item.topimg.type==4" target="_blank">
                                                <img :src="item.topimg.cover" :title="item.topimg.title">
                                            </a>
                                            <router-link :to="'/special/node_'+item.topimg.basic_id+'.html'" v-else-if="item.topimg.type==3" target="_blank">
                                                <img :src="item.topimg.cover" :title="item.topimg.title">
                                            </router-link>
                                            <router-link :to="'/video/show-'+item.topimg.basic_id+'.html'" v-else-if="item.topimg.type==2" target="_blank">
                                                <img :src="item.topimg.cover" :title="item.topimg.title">
                                            </router-link>
                                            <router-link :to="'/album/show-'+item.topimg.basic_id+'.html'" v-else-if="item.topimg.type==1" target="_blank">
                                                <img :src="item.topimg.cover" :title="item.topimg.title">
                                            </router-link>
                                            <router-link :to="'/article/show-'+item.topimg.basic_id+'.html'" v-else target="_blank">
                                                <img :src="item.topimg.cover" :title="item.topimg.title">
                                            </router-link>
                                        </div>
                                        <div class="tit">
                                            <a :href="item.topimg.link" v-if="item.topimg.type==4" target="_blank">
                                                {{item.topimg.title}}
                                            </a>
                                            <router-link :to="'/special/node_'+item.topimg.basic_id+'.html'" v-else-if="item.topimg.type==3" target="_blank">
                                                {{item.topimg.title}}
                                            </router-link>
                                            <router-link :to="'/video/show-'+item.topimg.basic_id+'.html'" v-else-if="item.topimg.type==2" target="_blank">
                                                {{item.topimg.title}}
                                            </router-link>
                                            <router-link :to="'/album/show-'+item.topimg.basic_id+'.html'" v-else-if="item.topimg.type==1" target="_blank">
                                                {{item.topimg.title}}
                                            </router-link>
                                            <router-link :to="'/article/show-'+item.topimg.basic_id+'.html'" v-else target="_blank">
                                                {{item.topimg.title}}
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="news-a-no" v-for="(news,index) in item.data" :key="index">
                                        <a :href="item.link" v-if="news.type==4" target="_blank">
                                            
                                            <div class="tit">{{news.title}}</div>
                                        </a>
                                        <router-link :to="'/special/node_'+news.basic_id+'.html'" v-else-if="news.type==3" target="_blank">
                                            
                                            <div class="tit">{{news.title}}</div>
                                        </router-link>
                                        <router-link :to="'/video/show-'+news.basic_id+'.html'" v-else-if="news.type==2" target="_blank">
                                            
                                            <div class="tit">{{news.title}}</div>
                                        </router-link>
                                        <router-link :to="'/album/show-'+news.basic_id+'.html'" v-else-if="news.type==1" target="_blank">
                                            
                                            <div class="tit">{{news.title}}</div>
                                        </router-link>
                                        <router-link :to="'/article/show-'+news.basic_id+'.html'" v-else target="_blank">
                                            
                                            <div class="tit">{{news.title}}</div>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="margin-top:15px;">
                    <div class="row">
                        <div class="col-xs-12 col-sm-6" v-for="(item,index) in twoline" :key="index" :class="{'bt_right': index == 0 ,'bt_left': index == 1}">
                            <div class="index_news">
                                <div class="index_news_tit">
                                    <div class="news_type">{{item.name}}</div>
                                    <div class="news_more">
                                        <router-link :to="'/list_'+item.id+'.html'">更多</router-link>
                                    </div>
                                    <div class="clear"></div>
                                </div>
                                <div class="index_news_list">
                                    <div class="news-a-no" v-for="(news,index) in item.data" :key="index">
                                        <a :href="item.link" v-if="news.type==4" target="_blank">
                                            
                                            <div class="tit">{{news.title}}</div>
                                        </a>
                                        <router-link :to="'/special/node_'+news.basic_id+'.html'" v-else-if="news.type==3" target="_blank">
                                            
                                            <div class="tit">{{news.title}}</div>
                                        </router-link>
                                        <router-link :to="'/video/show-'+news.basic_id+'.html'" v-else-if="news.type==2" target="_blank">
                                            
                                            <div class="tit">{{news.title}}</div>
                                        </router-link>
                                        <router-link :to="'/album/show-'+news.basic_id+'.html'" v-else-if="news.type==1" target="_blank">
                                            
                                            <div class="tit">{{news.title}}</div>
                                        </router-link>
                                        <router-link :to="'/article/show-'+news.basic_id+'.html'" v-else target="_blank">
                                            
                                            <div class="tit">{{news.title}}</div>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</view>
</template>
<script>
    import HeaderPage from '@/components/HeaderUnit.vue'
    import { post } from '../../request'; 
    export default {
        components: {
            HeaderPage
        },
        data() {
            return {
                lingdao: [],  
                oneline: [
                    { id: 73, name: '部门', data: [], topimg: {} },  
                    { id: 72, name: '乡镇', data: [], topimg: {} },  
                ],  
                twoline: [
                    { id: 92, name: '政策法规', data: [] },  
                    { id: 79, name: '通知公告', data: [] },  
                ],  
                peoples: [  
                    { id: 15, name: '县委', data: [] },  
                    { id: 16, name: '人大', data: [] },  
                    { id: 17, name: '政府', data: [] },  
                    { id: 18, name: '政协', data: [] },  
                ],  
                title: '政务-巧家新闻网—巧家县第一新闻门户网站',
                keywords: ['巧家新闻','巧家','白鹤滩','巧家县','巧家新闻网'],
                description: '巧家县第一新闻门户网站，巧家新闻网由中共巧家县委宣传部主办、巧家县人民政府新闻中心承办，是对外宣传推介巧家、展示巧家形象、外界了解巧家的重要网络平台。',
            }
        },
        mounted(){
            this.setTitle();  
            this.setKeywords();  
            this.setDescription();  
        },
        computed: {  
            // 使用计算属性来过滤出cover不为空的新闻  
            newsfoucs() {  
                return this.lingdao.filter(news => news.cover).length>0?this.lingdao.filter(news => news.cover):[];  
            },  
        }, 
        created() {
            this.getLingdao()
            this.getPeople()
            this.getOneline()
            this.getTwoline()
            //console.log(this.oneline);

        },
        methods: {
            isObjectEmpty(obj) {  
                return JSON.stringify(obj) === '{}';  
            },  

            setTitle() {  
                document.title = this.title; // 设置标题  
            },  
            setKeywords() {  
                const metaKeywords = document.createElement('meta');  
                metaKeywords.name = 'keywords';  
                metaKeywords.content = this.keywords.join(','); // 设置关键词  
                document.head.appendChild(metaKeywords);  
            },  
            setDescription() {  
                const metaDescription = document.createElement('meta');  
                metaDescription.name = 'description';  
                metaDescription.content = this.description; // 设置描述  
                document.head.appendChild(metaDescription);  
            },  
            async getLingdao() {  
                let that = this
                try {  
                    const postData = {'page': 1,'length': 6};  
                    const response = await post('column/90', postData);  
                    //console.log(response)
                    that.lingdao = response.data
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
           async getOneline() {  
                try {  
                    for (const onelines of this.oneline) { 
                        const postData = {'page': 1,'length': 5};
                        const response = await post(`column/${onelines.id}`, postData);  
                        if (response.data) {  
                            onelines.data = response.data;
                            const topNews = response.data.find(news => news.cover);   
                            if (topNews) {  
                                onelines.topimg = topNews;  
                            } else {  
                                onelines.topimg = {}; 
                            }                         
                        }  
                    }  
                } catch (error) {  
                    console.error('Error fetching institution data:', error);  
                }  
            },    
            async getTwoline() {  
                try {  
                    for (const twolines of this.twoline) { 
                        const postData = {'page': 1,'length': 5};
                        const response = await post(`column/${twolines.id}`, postData);  
                        if (response.data) {  
                            twolines.data = response.data; 
                        }  
                    }  
                } catch (error) {  
                    console.error('Error fetching institution data:', error);  
                }  
            },    
            async getPeople() {  
                try {  
                    for (const people of this.peoples) { 
                        const postData = {};  
                        const response = await post(`page/links/${people.id}`, postData);  
                        if (response.data) {  
                            people.data = response.data; 
                        }  
                    }  
                } catch (error) {  
                    console.error('Error fetching institution data:', error);  
                }  
            },    
        },
    }
</script>
  